import { createSelector } from '@reduxjs/toolkit';
const reduxAssetFlagsReducer = (state) => state.reduxAssetFlags;
export const reduxAssetFlagsDataSelector = createSelector(reduxAssetFlagsReducer, (reducer) => reducer.data);
